import { useTranslation } from 'react-i18next'

const LivingRoom = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="livingroom-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="livingroom-title">{t('antagonists:sibling:components:background')}</title>
      <defs>
        <clipPath id="livingroom-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="livingroom-c">
          <path
            d="M1470.05 582.68c7.73 5.82 8.72 27.42-18.99 66.72-25.37 35.99-43.81 37.61-51.64 38.68-8.06 1.11-89.82-13.11-93.89-20.66s10.45-49.43 29.11-72.83c19.56-24.53 44.67-40.72 56.79-39.85 11.97.87 62.59 15.87 78.62 27.94Z"
            style={{
              fill: '#4aa83f',
            }}
          />
        </clipPath>
        <clipPath id="livingroom-d">
          <path
            d="M1365.25 600.61c6.33 4.74 7.25 24.6-17.26 64.93-24.51 40.33-41.18 42.24-48.23 43.49-7.22 1.28-72.75-14.23-74.33-22.14-1.58-7.91 17.4-48.23 34.79-69.58 17.4-21.35 37.16-35.58 45.86-35.58s46.52 9.4 59.17 18.89Z"
            style={{
              fill: '#ef9cad',
            }}
          />
        </clipPath>
        <clipPath id="livingroom-e">
          <path
            style={{
              fill: '#d6c4c9',
            }}
            d="m1236 388.07-344.26.59.05-238.52 340.54.94 3.67 236.99z"
          />
        </clipPath>
        <clipPath id="livingroom-f">
          <path
            style={{
              fill: '#497125',
            }}
            d="m1367.79 145.95 2.41 207.64 158.49-.07-1.39-208.94-159.51 1.37z"
          />
        </clipPath>
        <clipPath id="livingroom-g">
          <path
            style={{
              fill: '#ef8227',
            }}
            d="m1666.12 858.82 91.45.58 10.56-110.44.15-18.3-115.28.63.62 18.07 12.5 109.46z"
          />
        </clipPath>
        <clipPath id="livingroom-h">
          <path
            d="M494.04 589.37c-7.2 4.74-5.97 19.53 21.95 59.86 27.91 40.33 38.75 42.44 46.78 43.7s109.05-21.82 110.85-29.73-14.11-46.49-33.92-67.84c-19.81-21.35-43.97-39.9-53.87-39.9-9.91 0-77.37 24.43-91.78 33.92Z"
            style={{
              fill: '#3d6b2a',
            }}
          />
        </clipPath>
        <style>
          {
            '.j{fill:none}.k{fill:#f4a019}.l{fill:#009250}.m{fill:#f5f2ed}.n{fill:#e9669e}.o{fill:#ef821b}.p{fill:#ef8227}.q{fill:#ef9cad}.r{fill:#f4e8d1}.s{fill:#e5cea4}.t{fill:#e52d87}.u{fill:#f0d8ab}.v{fill:#656898}.w{fill:#009c31}.x{fill:#72ad1e}.y{fill:#b1d5e8}.aa{fill:#cd5a30}.ab{fill:#d0b468}.ac{fill:#dce5df}.ad{fill:#d8e9ce}.ae{fill:#d6c4c9}.af{fill:#428a3d}.ag{fill:#3d6b2a}.ah{fill:#62ac6d}.ai{fill:#2e425b}.aj{fill:#3a4b36}.ak{fill:#352e50}.al{fill:#497125}.am{fill:#78bae2}.an{fill:#4aa83f}.ao{fill:#70aa63}.ap{clip-path:url(#livingroom-c)}.aq{clip-path:url(#livingroom-b)}.ar{clip-path:url(#livingroom-f)}.as{clip-path:url(#livingroom-e)}.at{clip-path:url(#livingroom-d)}.au{clip-path:url(#livingroom-h)}.av{clip-path:url(#livingroom-g)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#livingroom-b)',
        }}
        id="livingroom-a"
      >
        <path
          style={{
            fill: '#dce5df',
          }}
          d="M-160.24-188.02h2251.88v1255.29H-160.24z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#a9cac8',
          }}
          d="M-303.46 760.28h2370.81v857.05H-303.46z"
        />
        <path
          d="m1441.4 820.79-1.59 85.99-27.07-1.59-1.59-74.84s33.44-7.96 30.26-9.55ZM532.91 833.53l-1.6 71.66-23.88 1.59-1.6-78.03 27.08 4.78z"
          style={{
            fill: '#352e50',
          }}
        />
        <path
          d="M1491.48 525.22c10.53 9.75 9.59 21.64 9.59 21.64l3.15 300.4-1057.13-.99.1-295.92s-.29-13.79 10.09-25.96c9.17-10.76 28.43-11.21 28.43-11.21l980.58 3.56s14.2-1.69 25.19 8.49Z"
          style={{
            fill: '#f4e8d1',
          }}
        />
        <path
          d="M1003.59 467.39c10.17-.33 404.79-.37 414.34-.1 11.82.34 16.11 7.38 16.11 16.38 0 17.26.63 147.63.17 161.74-.26 7.91-5.02 13.12-13.49 13.12-14.62 0-406.85.77-418.93.77s-14.5-6.49-14.5-16.74-.17-153.55.12-161.87c.29-8.07 5.03-12.94 16.18-13.3ZM548.5 467.39c10.17-.33 404.79-.37 414.34-.1 11.82.34 16.11 7.38 16.11 16.38 0 17.26.63 147.63.17 161.74-.26 7.91-5.02 13.12-13.49 13.12-14.62 0-406.85.77-418.93.77s-14.5-6.49-14.5-16.74-.17-153.55.12-161.87c.29-8.07 5.03-12.94 16.18-13.3Z"
          style={{
            fill: '#f0d8ab',
          }}
        />
        <path
          d="M1004.6 668.1c10.67-.34 424.91-.39 434.94-.1 12.41.35 16.92 7.75 16.92 17.19 0 18.12.66 64.23.17 79.03-.27 8.3-5.27 13.77-14.16 13.77-15.35 0-427.07.81-439.75.81s-15.22-6.81-15.22-17.57c0-10.76.13-63.34.13-79.17 0-8.48 5.28-13.59 16.98-13.96ZM526.83 668.1c10.67-.34 424.91-.39 434.94-.1 12.41.35 16.92 7.75 16.92 17.19 0 18.12.66 64.23.17 79.03-.27 8.3-5.27 13.77-14.16 13.77-15.35 0-427.07.81-439.75.81s-15.22-6.81-15.22-17.57c0-10.76.13-63.34.13-79.17 0-8.48 5.28-13.59 16.98-13.96Z"
          style={{
            fill: '#e5cea4',
          }}
        />
        <path
          d="M1470.05 582.68c7.73 5.82 8.72 27.42-18.99 66.72-25.37 35.99-43.81 37.61-51.64 38.68-8.06 1.11-89.82-13.11-93.89-20.66s10.45-49.43 29.11-72.83c19.56-24.53 44.67-40.72 56.79-39.85 11.97.87 62.59 15.87 78.62 27.94Z"
          style={{
            fill: '#4aa83f',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom-c)',
          }}
        >
          <path
            d="M1492.39 618.95s-20.53-20.87-43.6-31.1c-22.41-9.93-151.84-45.25-151.84-45.25l-3.98 8.18s141.04 38.95 154.2 45.85c12.75 6.69 36.07 26.67 36.07 26.67l9.16-4.36ZM1502.85 600.93s-20.55-22.12-43.88-33.1c-22.69-10.68-154.44-49.27-154.44-49.27l-4.15 8.61s143.51 42.49 156.81 49.88c12.87 7.16 36.28 28.36 36.28 28.36l9.38-4.48Z"
            style={{
              fill: '#009c31',
            }}
          />
          <path
            d="M1481.04 634.46s-20.63-19.85-43.56-29.46c-22.26-9.33-150.12-42-150.12-42l-3.82 7.84s139.39 36.07 152.48 42.58 36.04 25.29 36.04 25.29l8.98-4.25ZM1465.5 651.27s-20.88-18.81-43.78-27.79c-22.2-8.71-148.99-38.68-148.99-38.68l-3.62 7.5s138.27 33.15 151.35 39.25c12.69 5.92 36.24 23.87 36.24 23.87l8.79-4.15ZM1451.87 669.62s-20.95-17.66-43.67-25.96c-22-8.03-146.89-35.12-146.89-35.12l-3.44 7.12s136.25 30 149.24 35.66 36.17 22.33 36.17 22.33l8.58-4.03ZM1438.15 686.7s-21.05-16.64-43.62-24.32c-21.84-7.43-145.12-31.96-145.12-31.96l-3.27 6.78s134.55 27.21 147.47 32.47c12.54 5.11 36.15 20.94 36.15 20.94l8.39-3.92ZM1414.61 698.85s-21.81-16.06-44.8-23.38c-22.24-7.08-147.01-30.08-147.01-30.08l-3.04 6.62s136.21 25.54 149.4 30.58c12.81 4.89 37.16 20.14 37.16 20.14l8.29-3.87Z"
            style={{
              fill: '#009c31',
            }}
          />
        </g>
        <path
          d="M1365.25 600.61c6.33 4.74 7.25 24.6-17.26 64.93-24.51 40.33-41.18 42.24-48.23 43.49-7.22 1.28-72.75-14.23-74.33-22.14-1.58-7.91 17.4-48.23 34.79-69.58 17.4-21.35 37.16-35.58 45.86-35.58s46.52 9.4 59.17 18.89Z"
          style={{
            fill: '#ef9cad',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom-d)',
          }}
        >
          <path
            d="M1149.84 635.39s65.4 32.03 148.16 10.68 86.76-40.04 126.8-42.71 100.11-4 100.11-4l-154.83 268.28-218.9-120.13 1.33-118.79"
            style={{
              fill: '#ef821b',
            }}
          />
        </g>
        <path
          d="m879.29 138.85 1.27 261.6 368.51-.65-3.86-259.23-.04-2.53-365.88.82Z"
          style={{
            fill: '#f5f2ed',
          }}
        />
        <path
          style={{
            fill: '#d6c4c9',
          }}
          d="m1236 388.07-344.26.59.05-238.52 340.54.94 3.67 236.99z"
        />
        <g
          style={{
            clipPath: 'url(#livingroom-e)',
          }}
        >
          <path
            style={{
              fill: '#d8e9ce',
            }}
            d="m860.04 422.14 389.98 2.97 2.67-301.96-389.99-2.97-2.66 301.96z"
          />
          <path
            d="M615.5 162.22c105.38-1.9 290.87-4.76 389.9 7.69 89.9 11.32 119.9 35.56 205.3 48.68 96.35 14.8 264.13 6.38 277.47 6.34l.54 21.04.17 1.34c-5.2-.02-782.13-.09-782.13-.09l-91.25-85.01Z"
            style={{
              fill: '#70aa63',
            }}
          />
          <path
            d="M966.51 285.33c25.79 0 41.91-5.25 53.68-11.67 11.69-6.38 19.78-12.79 33.98-19.98 15.14-7.65 50.89-9.32 79.78-8.92 45.43.61 346.19 1.5 346.19 1.5l-15.59 106.96-753.05 44.94-2.86-112.83h257.88Z"
            style={{
              fill: 'none',
            }}
          />
          <path
            d="M1033.69 327.3c-120.61 19.06-398.48 5.59-398.48 5.59l44.32-96.14h816.54l1.52 34.87s-387.24 43.57-463.89 55.68Z"
            style={{
              fill: '#656898',
            }}
          />
          <path
            d="M1567.74 245.28s-474.8 8.05-487.08 8.45c-12.27.41-29.62.11-30.11 11.06-.5 11.29 10.44 11.55 19.15 13.73 4.05 1.01 11.18 3 10.83 12.06-.38 9.71-9.22 12.58-24.4 11.62-16.49-1.04-668.89 2.68-668.89 2.68l8.73 67.47 1141.7-2.14 30.07-124.92Z"
            style={{
              fill: '#78bae2',
            }}
          />
          <path
            d="M1522.95 304.01s-273.62-1.81-300.42-1.94c-26.8-.13-48.33-2.16-49.34 8.9-1.1 11.89 13.47 11.62 31.11 13.47 7.04.73 11.44 6.09 11.14 11.5-.44 8.01-7.12 11.75-23.13 11.75-30.77 0-487.81 2.46-487.81 2.46l-1.62 190.43 833.53 13.07-13.46-249.63Z"
            style={{
              fill: '#b1d5e8',
            }}
          />
        </g>
        <path
          style={{
            fill: '#352e50',
          }}
          d="m112.46 367.49-2.48 530.27 9.09.83 1.66-531.1h-8.27z"
        />
        <path
          style={{
            fill: '#352e50',
          }}
          d="m27.24 494.91 2.71 7.23 264.44-127.07-2.09-6.36-265.06 126.2z"
        />
        <path
          d="m287.26 359.57 15.38-6.04 55.76 74.65s-13.08 6.09-33.7 13.55c-20.4 7.38-33.86 9.28-33.86 9.28l-3.57-91.44Z"
          style={{
            fill: '#352e50',
          }}
        />
        <path
          style={{
            fill: '#352e50',
          }}
          d="m294.27 348.47-.88 11.05 2.66-.64.5-10.03-2.28-.38zM67.41 894.76l-.48 10.41 98.97-.22v-8.23a7.69 7.69 0 0 0-7.65-7.69l-84.37-.41a6.434 6.434 0 0 0-6.46 6.14ZM115.32 446.83c-10.68.14-14.23 7.95-13.73 14.71.69 9.43 7.05 12.62 14.29 12.62 9.57 0 14.01-6.94 14.01-14.84s-6.66-12.59-14.57-12.49Z"
        />
        <path
          d="M115.51 453.55c-5.43.07-7.23 4.04-6.98 7.47.35 4.79 3.58 6.42 7.26 6.42 4.87 0 7.12-3.53 7.12-7.54s-3.39-6.4-7.4-6.35Z"
          style={{
            fill: '#e9669e',
          }}
        />
        <path
          d="M1561.12 104.45c-2.47.31-1.54-4.01-1.54-4.01l-4.01-1.85-3.7 5.86s-4.01-5.24-9.25-5.24-8.33 7.4-20.66 12.95c-5.44 2.45-8.84 1.78-10.94.26 1.38-.56 2.39-2.06 2.39-4.05 0-2.72-1.78-3.84-3.9-3.77s-3.65 1.61-3.65 4.08c0 .06.01.11.01.16-2.57 1.9-7.9 4.96-16.91 6.39-7.98 1.27-13.82-1.51-17.28-4.02.84-.75 1.38-1.95 1.38-3.41 0-2.72-1.78-3.84-3.9-3.77-2.11.07-3.65 1.61-3.65 4.08 0 1.84.79 2.95 1.98 3.52-.59.97-1.64 1.94-3.51 2.67-5.55 2.16-11.72-5.86-11.72-5.86l-10.06-.15s-3.51 6.93-9.37 6.93c-2.34 0-3.59-1.19-4.26-2.61h.05c2.1.18 3.9-1.61 3.9-4.27 0-2.72-1.78-3.84-3.9-3.77s-3.65 1.61-3.65 4.08c0 .47.07.87.16 1.25-2.36 1.43-6.48 3.35-13.27 5-7.78 1.9-14.86-1.7-19.16-4.74.25-.59.4-1.26.4-2 0-2.72-1.78-3.84-3.9-3.77-2.11.07-3.65 1.61-3.65 4.08 0 1.42.47 2.4 1.24 3.04-.79.62-1.85 1.25-3.3 1.85-7.4 3.08-19.43-11.1-25.59-12.95-6.17-1.85-10.79 3.08-12.64 4.01-1.85.93-2.78-3.7-2.78-3.7l-3.08.62s0 3.08-2.78 4.63c-2.78 1.54-9.25-5.24-9.25-5.24l-4.32 3.7s5.72 6.21 5.55 9.87c-.09 1.97-4.01 2.47-4.01 2.47l-.92 3.7 4.01 3.08s-6.38 5.89-2.16 17.27c2.4 6.47 7.71 13.57 9.56 20.35.56 2.04.19 3.58-.6 4.74-.64-1.31-1.97-1.88-3.47-1.83-2.11.07-3.65 1.61-3.65 4.08 0 2.6 1.55 3.78 3.65 3.96h.04c1.88 2.91 4.54 8.41 6.81 18.34 2.63 11.53-.98 19.88-3.77 24.26-.62-.32-1.36-.46-2.14-.44-2.11.07-3.65 1.61-3.65 4.08 0 2.6 1.55 3.78 3.65 3.96.89.08 1.72-.2 2.38-.75.95 1.96 1.58 4.93.76 9.28-1.85 9.87-8.02 13.57-8.02 13.57v7.23s6.17 3.7 8.02 13.57c.82 4.35.19 7.32-.76 9.28-.67-.55-1.5-.82-2.38-.75-2.1.18-3.65 1.36-3.65 3.96 0 2.47 1.54 4.01 3.65 4.08.79.03 1.52-.11 2.14-.44 2.79 4.38 5.51 12.56 3.77 24.26-1.46 9.85-4.92 15.43-6.81 18.34h-.04c-2.1.18-3.65 1.36-3.65 3.96 0 2.47 1.54 4.01 3.65 4.08 1.51.05 2.83-.52 3.47-1.83.78 1.15 1.15 2.69.6 4.74-1.85 6.78-7.16 13.89-9.56 20.35-4.22 11.38 2.16 17.27 2.16 17.27l-4.01 3.08.93 3.7s3.92.49 4.01 2.47c.17 3.66-5.55 9.87-5.55 9.87l4.32 3.7s6.48-6.78 9.25-5.24c2.78 1.54 2.78 4.63 2.78 4.63l3.08.62s.93-4.63 2.78-3.7c1.85.93 6.48 5.86 12.64 4.01 6.17-1.85 18.19-16.03 25.59-12.95 1.45.6 2.52 1.23 3.3 1.85-.76.64-1.24 1.62-1.24 3.05 0 2.47 1.54 4.01 3.65 4.08 2.11.07 3.9-1.05 3.9-3.77 0-.75-.15-1.42-.4-2 4.29-3.04 11.37-6.64 19.16-4.74 6.79 1.66 10.91 3.58 13.27 5-.09.38-.16.78-.16 1.25 0 2.47 1.54 4.01 3.65 4.08 2.11.07 3.9-1.05 3.9-3.77 0-2.65-1.8-4.45-3.9-4.27h-.05c.67-1.42 1.91-2.61 4.26-2.61 5.86 0 9.37 6.93 9.37 6.93l10.06-.15s6.17-8.02 11.72-5.86c1.87.73 2.92 1.7 3.51 2.67-1.2.57-1.98 1.68-1.98 3.52 0 2.47 1.54 4.01 3.65 4.08 2.11.07 3.9-1.05 3.9-3.77 0-1.46-.54-2.65-1.38-3.41 3.46-2.51 9.3-5.29 17.28-4.02 9.01 1.43 14.34 4.5 16.91 6.39 0 .06-.01.11-.01.16 0 2.47 1.54 4.01 3.65 4.08 2.11.07 3.9-1.05 3.9-3.77 0-1.98-1.01-3.49-2.39-4.05 2.1-1.51 5.5-2.19 10.94.26 12.33 5.55 15.42 12.95 20.66 12.95s9.25-5.24 9.25-5.24l3.7 5.86 4.01-1.85s-.93-4.32 1.54-4.01c2.47.31 12.03 6.48 12.03 6.48l3.7-4.32s-6.17-5.24-7.09-8.63c-.92-3.39 5.5-.66 5.5-.66l1.54-3.7-6.12-8.9s6.17-5.86 1.54-12.64-13.26-18.81-10.48-24.05c.71-1.34 1.44-2.38 2.14-3.16.63 1.11 1.74 1.76 3.09 1.8 2.11.07 3.9-1.05 3.9-3.77 0-2.65-1.8-4.45-3.9-4.27-.87.08-1.64.33-2.25.78-2.85-4.58-6.56-12.57-6.38-21.6.2-9.79 3.65-17.7 5.95-21.92.55.35 1.2.56 1.92.58 2.11.07 3.9-1.05 3.9-3.77 0-2.65-1.8-4.45-3.9-4.27-1.09.1-2.03.47-2.69 1.17-1.4-1.97-2.73-4.91-2.42-8.79.62-7.71 8.63-15.73 8.63-15.73v-8.46s-8.02-8.02-8.63-15.73c-.31-3.88 1.02-6.82 2.42-8.79.65.7 1.59 1.07 2.69 1.17 2.1.18 3.9-1.62 3.9-4.27 0-2.72-1.78-3.84-3.9-3.77-.72.02-1.37.23-1.92.58-2.31-4.23-5.75-12.13-5.96-21.92-.19-9.03 3.52-17.02 6.38-21.6.61.45 1.38.71 2.25.78 2.09.18 3.9-1.61 3.9-4.27 0-2.72-1.78-3.84-3.9-3.77-1.35.04-2.46.69-3.09 1.8-.7-.78-1.43-1.82-2.14-3.16-2.78-5.24 5.86-17.27 10.48-24.05 4.63-6.78-1.54-12.64-1.54-12.64l6.12-8.9-1.54-3.7s-6.43 2.73-5.5-.66c.93-3.39 7.09-8.63 7.09-8.63l-3.7-4.32s-9.56 6.17-12.03 6.48Z"
          style={{
            fill: '#d0b468',
          }}
        />
        <path
          style={{
            fill: '#497125',
          }}
          d="m1367.79 145.95 2.41 207.64 158.49-.07-1.39-208.94-159.51 1.37z"
        />
        <g
          style={{
            clipPath: 'url(#livingroom-f)',
          }}
        >
          <path
            style={{
              fill: '#e52d87',
            }}
            d="m1422.99 195.81 2.5 186.85 4.12.08-3.38-187.61-3.24.68z"
          />
          <path
            d="M1426.8 382.24s4.11-54.07 5.46-93.58c1.31-38.25 10.76-67.64 10.76-67.64s16.38 56.01 7.34 85.74c-9.05 29.72-20.22 75.44-20.22 75.44l-3.33.05Z"
            style={{
              fill: '#e52d87',
            }}
          />
          <path
            d="m1421.21 381.67 6.45.04s-.74-96.99-6.91-121.67c-6.17-24.67-43.18-50.37-43.18-50.37s26.07 68.79 33.95 86.92c10.5 24.14 9.68 85.08 9.68 85.08ZM1405.75 155.42s-6.82 50.91 17.32 49.86c24.14-1.05 20.99-24.14 18.89-32.01-2.1-7.87-6.82-23.62-6.82-23.62l-3.67 13.12-12.07-17.32-4.72 15.22-8.92-5.25Z"
            style={{
              fill: '#e52d87',
            }}
          />
          <path
            style={{
              fill: '#f4a019',
            }}
            d="m1472.29 221.97-3.34 184.96-4.12.08 4.22-185.72 3.24.68z"
          />
          <path
            d="M1463.12 407.05s-6.45-51.75-15.88-90.15c-9.13-37.18-8.02-68.03-8.02-68.03s30.99 49.48 30.35 80.54c-.64 31.06-3.26 76.68-3.26 76.68l-3.19.95ZM1472.85 406.7l-4.94-.47s9.88-94.58 17.17-118.63c7.28-24.05 38.27-46.65 38.27-46.65s-27.09 66.33-35.01 83.74c-10.54 23.17-15.49 82.01-15.49 82.01ZM1496.63 198.78s2.66 50.36-21.48 49.31c-24.14-1.05-20.99-24.14-18.89-32.01 2.1-7.87 7.48-22.32 7.48-22.32l6.85 8.68 8.23-14.18 4.72 15.22 13.09-4.7Z"
            style={{
              fill: '#f4a019',
            }}
          />
        </g>
        <path
          d="M1697.59 794.2s-24.29-50.61-32.39-107.29c-8.1-56.68-14.17-186.24-14.17-186.24l10.12 4.05s20.24 99.19 26.32 153.85c6.07 54.66 20.25 133.61 20.25 133.61l-10.12 2.02Z"
          style={{
            fill: '#3a4b36',
          }}
        />
        <path
          d="M1711.11 761.9s-6.07-145.76 0-204.46c6.07-58.71 10.12-97.17 10.12-97.17h14.17s8.1 60.73 4.05 121.46-16.2 184.22-16.2 184.22l-12.15-4.05Z"
          style={{
            fill: '#428a3d',
          }}
        />
        <path
          d="M1725.52 797.08s.24-1.4.67-3.96c2.63-15.61 12.33-74.3 17.55-119.53 6.07-52.63 20.24-139.68 20.24-139.68l10.12 2.02s0 66.81-12.15 133.61c-12.15 66.81-24.29 133.61-24.29 133.61l-12.15-6.07Z"
          style={{
            fill: '#3d6b2a',
          }}
        />
        <path
          d="M1705.53 760.7s-20.25-147.78-28.34-244.95c-8.1-97.17-20.25-170.05-20.25-170.05l12.27-.91s30.21 101.61 34.33 184c4.12 82.39 8.24 221.08 8.24 221.08l-6.25 10.83Z"
          style={{
            fill: '#009250',
          }}
        />
        <path
          style={{
            fill: '#ef8227',
          }}
          d="m1666.12 858.82 91.45.58 10.56-110.44.15-18.3-115.28.63.62 18.07 12.5 109.46z"
        />
        <g
          style={{
            clipPath: 'url(#livingroom-g)',
          }}
        >
          <path
            style={{
              fill: '#cd5a30',
            }}
            d="m1637.14 771.25 148.59-3.14-3.33-61.81-157.61 7.33 12.35 57.62z"
          />
        </g>
        <path
          d="M494.04 589.37c-7.2 4.74-5.97 19.53 21.95 59.86 27.91 40.33 38.75 42.44 46.78 43.7s109.05-21.82 110.85-29.73-14.11-46.49-33.92-67.84c-19.81-21.35-43.97-39.9-53.87-39.9-9.91 0-77.37 24.43-91.78 33.92Z"
          style={{
            fill: '#3d6b2a',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom-h)',
          }}
        >
          <path
            d="M594.03 650.46c0 17.1 4.8 32.31 30.14 34.15 25.34 1.85 42.81-12.46 41.06-32.77-1.75-20.31-13.29-36.78-38.18-36.25-21.41.46-33.02 16.86-33.02 34.86Z"
            style={{
              fill: '#72ad1e',
            }}
          />
          <path
            d="M565.05 580.99c0 17.1 4.8 32.31 30.14 34.15 25.34 1.85 42.81-12.46 41.06-32.77-1.75-20.31-13.29-36.78-38.18-36.25-21.41.46-33.02 16.86-33.02 34.86Z"
            style={{
              fill: '#2e425b',
            }}
          />
          <path
            d="M487.9 646.79c0 23.54 6.69 44.46 41.99 47.01 35.3 2.54 59.64-17.15 57.21-45.1-2.43-27.95-18.26-47.74-52.95-47-29.82.63-46.25 20.33-46.25 45.1Z"
            style={{
              fill: '#62ac6d',
            }}
          />
        </g>
      </g>
    </svg>
  )
}

export default LivingRoom
